import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Cards from '../Cards.jsx';
import Categories from '../Categories.jsx';
import Filter from '../Filter.jsx';
import Search from '../Search.jsx';
import SearchLabels from '../SearchLabels.jsx';
import t from '../utils/i18n.js';

import CountUp from 'react-countup';

import { useLocation } from 'react-router-dom';

const Courses = (props) => {

    const [ btnVisible, setBtnVisible ] = useState(false);
    const containerRef = useRef(null);

    const onSubmit = (event) => {
        event.preventDefault();
    };

    const callbackFunction = (entries) => {
        const [ entry ] = entries;
        setBtnVisible(entry.intersectionRatio < 1);
    }

    const options = {threshold: [1]};

    useEffect(() => {
        const observer = new IntersectionObserver(callbackFunction, options);
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        }
    }, [containerRef, options]);

    if (props.lang !== 'en') {
        let location = useLocation();

        useEffect(() => {
            document.getElementById('hero-img-courses').classList.add('hero__picture--active');
            document.getElementById('hero-img-schools').classList.remove('hero__picture--active');
            const header = document.querySelector('.hero__text');
            header.classList.remove('hero__text--schools');
            header.classList.add('hero__text--courses');
        }, [location]);
    }

    const [priceBrackets, setPriceBrackets] = useState(props.options.courses.price);
    let currentCourseType = 'whole';

    useEffect(() => {
        let onlyHalfyearCoursesSelected = true;
        if (props.filters.courses.courseType) {
            props.filters.courses.courseType.forEach((type) => {
                if (!type.startsWith('h')) {
                    onlyHalfyearCoursesSelected = false;
                }
            });
        } else {
            onlyHalfyearCoursesSelected = false
        }
        if (onlyHalfyearCoursesSelected) {
            setPriceBrackets(props.options.courses.priceHalfyear);
            if (currentCourseType === 'whole') {
                props.filters.courses.price = [];
                currentCourseType = 'half';
            }
        } else {
            setPriceBrackets(props.options.courses.price);
            if (currentCourseType === 'half') {
                props.filters.courses.price = [];
                currentCourseType = 'whole';
            }
        }
    }, [props.filters.courses.courseType]);

    const courses = (
        <form onSubmit={onSubmit}>
            <div className={'sorting__courses-bk' + (props.isRestplass ? ' sorting__courses-bk--restplass' : '')}>
                <div className={'sorting__container sorting__container--courses' + (props.isRestplass ? ' sorting__container--restplass' : '')} id="course-filtering">
                    <div className="sorting__container-content">
                        <div className="sorting__categories">
                            <div className="sorting__description">
                                <h2>{t("Fagområder", props.lang) }</h2>
                                <p>{t("Her kan du velge én eller flere fagområder og underkategorier for å spisse søket ditt.", props.lang)}</p>
                                <div className="sorting__category-label">{t("Fagområde", props.lang) }:</div>
                            </div>
                            <Categories
                                categories={props.categories}
                                selectedCategory={props.filters.courses.category}
                                selectedSubCategory={props.filters.courses.subCategory}
                                facets={props.facets}
                                setCategory={props.setCategory}
                                resetFilters={props.resetFilters}
                                isRestplass={props.isRestplass}
                                lang={props.lang}
                            />
                            <div className={'filter__show-result filter__show-result--main' + (props.filters.active ? ' filter__show-result--hide' : '')}>
                                <button className="button button--primary" onClick={() => props.showWholeyearCourses()}>
                                    {t("Vis", props.lang)} <CountUp end={props.facets.wholeyear} duration={1} preserveValue={true}></CountUp> {t(props.facets.wholeyear === 1 ? "helårslinje" : "helårslinjer", props.lang)}
                                </button>
                                <button className="button button--additional" onClick={() => props.showHalfyearCourses()}>
                                    {t("Vis", props.lang)} <CountUp end={props.facets.halfyear} duration={1} preserveValue={true}></CountUp> {t(props.facets.halfyear === 1 ? "halvårslinje" : "halvårslinjer", props.lang)}
                                </button>
                            </div>
                        </div>
                        <div className={'sorting sorting--courses sorting--courses-filtering sorting--courses-' + props.lang} id="sort-filters">
                            <div className="filter__header">{t('Flere valg', props.lang)}:</div>
                            <Filter
                                type="courseType"
                                title="Kurslengde"
                                options={props.options.courses.courseType}
                                checked={props.filters.courses.courseType}
                                sort={props.filterCourses}
                                trackingCategory="linjesøk"
                                trackingAction="kurslengde"
                                lineCount={props.filteredCourses.length}
                                lang={props.lang}
                            />
                            <Filter
                                type="christian"
                                title="Verdigrunnlag"
                                options={props.options.courses.religion}
                                checked={props.filters.courses.christian}
                                sort={props.filterCourses}
                                trackingCategory="linjesøk"
                                trackingAction="tilknytning"
                                lineCount={props.filteredCourses.length}
                                lang={props.lang}
                            />
                            <Filter
                                type="region"
                                title="Landsdel"
                                options={props.options.courses.region}
                                checked={props.filters.courses.region}
                                sort={props.filterCourses}
                                trackingCategory="linjesøk"
                                trackingAction="landsdel"
                                lineCount={props.filteredCourses.length}
                                lang={props.lang}
                            />
                            <Filter
                                type="price"
                                title="Pris"
                                options={priceBrackets}
                                checked={props.filters.courses.price}
                                sort={props.filterCourses}
                                trackingCategory="linjesøk"
                                trackingAction="pris"
                                lineCount={props.filteredCourses.length}
                                lang={props.lang}
                            />
                            { props.lang == 'en' ?
                                <Filter
                                    type="lt"
                                    title="Language training"
                                    options={props.options.courses.lt}
                                    checked={props.filters.courses.lt}
                                    sort={props.filterCourses}
                                    trackingCategory="linjesøk"
                                    trackingAction="språkopplæring"
                                    lineCount={props.filteredCourses.length}
                                    lang={props.lang}
                                />
                                : ''
                            }
                            <Search
                                sort={props.filterCourses}
                                value={props.filters.courses.name}
                                placeholder={t("Skriv inn linjenavn", props.lang)}
                            />
                            <div className="sorting__tools">
                                {/*
                                <div className="sorting__count">
                                    {props.filteredCourses.length} {t("linjer", props.lang)}
                                </div>
                                <button
                                    className={'button button--reset' + (props.filtersActive ? ' button--reset--active' : '') }
                                    onClick={() => props.resetFilters()}
                                > {t("Nullstill", props.lang)}
                                </button>
                                */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'filter__show-result filter__show-result--bottom' + (props.filters.active ? ' filter__show-result--sticky' : '') + (btnVisible ? ' filter__show-result--stuck' : '') + (props.isRestplass ? ' filter__show-result--restplass' : '')} ref={containerRef}>
                    <div>
                        <button className="button button--primary" onClick={() => props.showWholeyearCourses()}>
                            {t("Vis", props.lang)} <CountUp end={props.facets.wholeyear} duration={1} preserveValue={true}></CountUp> {t(props.facets.wholeyear === 1 ? "helårslinje" : "helårslinjer", props.lang)}
                        </button>
                        <button className="button button--additional" onClick={() => props.showHalfyearCourses()}>
                            {t("Vis", props.lang)} <CountUp end={props.facets.halfyear} duration={1} preserveValue={true}></CountUp> {t(props.facets.halfyear === 1 ? "halvårslinje" : "halvårslinjer", props.lang)}
                        </button>
                    </div>
                </div>
            </div>
            <div className="filter__breadcrumbs" id="linjer">
                <nav className="breadcrumb">
                    <ul>
                        <li className="breadcrumb__item"><a href="/">{t('Hjem', props.lang)}</a></li>
                        <li className="breadcrumb__item"><a href="#" onClick={(e) => { e.preventDefault(); document.getElementById('course-filtering').scrollIntoView({ behavior: 'smooth' }); }}>{t('Finn din linje', props.lang)}</a></li>
                        <li className="breadcrumb__item">{t('Resultat', props.lang)}</li>
                    </ul>
                </nav>
            </div>
            <SearchLabels filters={props.filters} filterCourses={props.filterCourses} setCategory={props.setCategory} lang={props.lang}></SearchLabels>
            <Cards courses={props.filteredCourses} prices={props.options.courses.price} lang={props.lang} standalone={false} limit={props.pageOffset} total={props.facets.total} loadMore={props.loadMore} />
        </form>
    );

    return (
        <div>
            {courses}
            { props.filteredCourses.length === 0 ? (
                <div className="search__empty">
                    <h2>Her fant vi ingen linjer, dessverre!</h2>
                    <p className="search__empty__links">
                        <a href="#" onClick={(e) => { e.preventDefault(); props.resetFilters(); } }>Nullstill søket</a>  eller <a href="/linjer/random" onClick={() => props.resetFilters()}>prøv lykken</a>
                    </p>
                </div>
            ) : null }
        </div>
    );
};

Courses.propTypes = {
    filteredCourses: PropTypes.array,
    filterCourses: PropTypes.func,
    loadMore: PropTypes.func,
    facets: PropTypes.object,
    shuffle: PropTypes.func,
    resetFilters: PropTypes.func,
    filtersActive: PropTypes.bool,
    categories: PropTypes.array,
    selectedCategory: PropTypes.string,
    selectedSubCategory: PropTypes.string,
    options: PropTypes.object,
    filters: PropTypes.object,
    setCategory: PropTypes.func,
    showWholeyearCourses: PropTypes.func,
    showHalfyearCourses: PropTypes.func,
    isRestplass: PropTypes.bool,
    category: PropTypes.string,
    lang: PropTypes.string,
    categoryCounts: PropTypes.object,
    mainCategoryCounts: PropTypes.object,
    pageOffset: PropTypes.number
};

export default Courses;
